var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email",
    fill: "#8DC63F",
    d: "M341.045,62.008H297.64c-75.425,0.083-136.5,61.295-136.417,136.72 c0.005,4.289,0.211,8.576,0.62,12.848c8.101,70.854,68.483,124.098,139.793,123.268h55.359c18.894,0.055,37.313-5.921,52.575-17.058 c5.433-4.14,6.48-11.899,2.343-17.333c-0.354-0.467-0.744-0.906-1.162-1.318l-8.92-8.919c-4.31-4.197-10.994-4.737-15.922-1.287 c-8.563,5.705-18.626,8.737-28.914,8.711H297.64c-54.853-0.062-99.271-44.577-99.209-99.431c0.002-2.194,0.078-4.39,0.226-6.578 c4.771-52.852,49.427-93.118,102.487-92.417h39.901c30.821,0,55.808,24.985,55.808,55.808v49.606 c0,10.272-8.328,18.602-18.603,18.602s-18.603-8.328-18.603-18.602V155.02c0.011-10.264-8.301-18.592-18.563-18.603 c-5.013-0.005-9.813,2.015-13.315,5.602c-7.453-3.643-15.633-5.557-23.928-5.602h-6.201c-34.246,0-62.008,27.762-62.008,62.008 s27.762,62.008,62.008,62.008h6.201c13.775-0.043,27.039-5.218,37.204-14.515c22.671,20.682,57.815,19.069,78.497-3.602 c9.396-10.298,14.576-23.752,14.516-37.69V155.02C434.058,103.651,392.415,62.008,341.045,62.008z M322.443,204.626 c-0.012,10.269-8.334,18.591-18.603,18.602h-6.201c-13.698,0-24.803-11.104-24.803-24.803s11.105-24.803,24.803-24.803h6.201 c10.269,0.011,18.591,8.333,18.603,18.602V204.626z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.11bedf60968e8fd57d143076df872797.svg";
export { ForwardRef as ReactComponent };